export const StorageKeyPrefix = 'blockey-labs';

export const StorageKey = {
  ACCESS_TOKEN: 'access-token',
  API_KEY: 'api-key',
}
